module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Lock-c135b04dadf248b4ad9154aa0a6c99c7.svg";